import { render } from "./MessagesView.vue?vue&type=template&id=0adeb09c"
import script from "./MessagesView.vue?vue&type=script&lang=js"
export * from "./MessagesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__